export default __webpack_public_path__ + "static/380-88eec93d150f99857fed72bcad1f20b3.jpg";